import { Modal } from "../../basic/modal";
import { useModalContext } from "../../providers";

function TlpModal(props: Props) {
	const { modal } = useModalContext();
	//Set as movable unless explicitly declared otherwise
	return <Modal {...modal} movable={modal.movable === false ? false : props.movable} />;
}

interface Props {
	movable?: boolean;
}

export default TlpModal;
